import { Route } from "react-router-dom";
import { _adr } from "../address";
import { Roles } from "../tools/services";
import { ProtectedRoute } from "../tools/protectedRoute";
import CartablePostList from "../components/postcartable/cartablePostList";

export const postCartableRoutes = [
	<Route
		key="cartable-post"
		path={_adr.Root + _adr.CartablePost.Index}
		element={<ProtectedRoute role={Roles.CRM_RegisterSim_Catable_Post} element={CartablePostList} />}
	/>,
];
